<article id="datacleaner-filters" [ngClass]="{'minimise': !showFilterOptions}">
  <form [formGroup]="cleanOptionsForm" id="datacleaner-filters-results">
    <h2 class="heading-underline">Select which Bullhorn records you want to include using the options below.</h2>
    <div id="plus-more" (click)="showFilterOptions = !showFilterOptions"><i class="bhi-sort-desc"></i></div>
    <div id="processing-filters" *ngIf="isLoading">
      <div class="app-loading">
        <svg class="spinner" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10"/>
        </svg>
      </div>
    </div>
      <!-- TODO: This should be a child form group and component -->
    <div class="form-section">
      <h2 class="heading-underline">Find missing information</h2>
      <ul id="filters">
        <ul class="filter-section">
          <li matTooltip="Select all in the section" matTooltipPosition="right">
              <i class="bhi-email option-group-icon" (click)="selectSection($event,'email,email2,email3')"></i>
          </li>
          <li class="novo-form-row">
              <app-filter-option-toggle [formGroup]="cleanOptionsForm" label="No Email" controlName="email"
                                 (toggle)="calculateTotal($event, 'email')"></app-filter-option-toggle>
          </li>
          <li class="novo-form-row">
            <app-filter-option-toggle [formGroup]="cleanOptionsForm" label="No Email 2" controlName="email2"
                               (toggle)="calculateTotal($event, 'email2')"></app-filter-option-toggle>
          </li>
          <li class="novo-form-row">
            <app-filter-option-toggle [formGroup]="cleanOptionsForm" label="No Email 3" controlName="email3"
                               (toggle)="calculateTotal($event, 'email3')"></app-filter-option-toggle>
          </li>
        </ul>
        <ul class="filter-section">
          <li matTooltip="Select all in the section" matTooltipPosition="right">
              <i class="bhi-phone option-group-icon" (click)="selectSection($event,'phone,phone2,phone3,workPhone,mobile')"></i>
          </li>
          <li class="novo-form-row">
            <app-filter-option-toggle [formGroup]="cleanOptionsForm" label="No Phone" controlName="phone"
                               (toggle)="calculateTotal($event, 'phone')"></app-filter-option-toggle>
          </li>
          <li class="novo-form-row">
            <app-filter-option-toggle [formGroup]="cleanOptionsForm" label="No Phone 2" controlName="phone2"
                               (toggle)="calculateTotal($event, 'phone2')"></app-filter-option-toggle>
          </li>
          <li class="novo-form-row">
            <app-filter-option-toggle [formGroup]="cleanOptionsForm" label="No Phone 3" controlName="phone3"
                               (toggle)="calculateTotal($event, 'phone3')"></app-filter-option-toggle>
          </li>
          <li class="novo-form-row" *ngIf=isCandidate>
            <app-filter-option-toggle [formGroup]="cleanOptionsForm" label="No Work Phone" controlName="workPhone"
                               (toggle)="calculateTotal($event, 'workPhone')"></app-filter-option-toggle>
          </li>
          <li class="novo-form-row">
            <app-filter-option-toggle [formGroup]="cleanOptionsForm" label="No Mobile" controlName="mobile"
                               (toggle)="calculateTotal($event, 'mobile')"></app-filter-option-toggle>
          </li>
        </ul>
        <ul class="filter-section">
          <li matTooltip="Select all in the section" matTooltipPosition="right">
              <i class="bhi-location option-group-icon" (click)="selectSection($event,'zip,city')"></i>
          </li>
          <li class="novo-form-row">
            <app-filter-option-toggle [formGroup]="cleanOptionsForm" label="No Postcode/Zip" controlName="zip"
                               (toggle)="calculateTotal($event, 'zip')"></app-filter-option-toggle>
          </li>
          <li class="novo-form-row">
            <app-filter-option-toggle [formGroup]="cleanOptionsForm" label="No City" controlName="city"
                               (toggle)="calculateTotal($event, 'city')"></app-filter-option-toggle>
          </li>
        </ul>
        <ul class="filter-section">
          <li matTooltip="Select all in the section" matTooltipPosition="right">
              <i class="bhi-notes option-group-icon" (click)="selectSection($event,'comments,skills,notes')"></i>
          </li>
          <li class="novo-form-row">
            <app-filter-option-toggle [formGroup]="cleanOptionsForm" label="No Comments" controlName="comments"
                               (toggle)="calculateTotal($event, 'comments')"></app-filter-option-toggle>
          </li>
          <li class="novo-form-row">
            <app-filter-option-toggle [formGroup]="cleanOptionsForm" label="No Skills" controlName="skills"
                               (toggle)="calculateTotal($event, 'skills')"></app-filter-option-toggle>
          </li>
          <li class="novo-form-row">
            <app-filter-option-toggle [formGroup]="cleanOptionsForm" label="No Notes" controlName="notes"
                               (toggle)="calculateTotal($event, 'notes')"></app-filter-option-toggle>
          </li>
        </ul>
        <ul class="filter-section">
          <li><i class="bhi-attach option-group-icon"></i></li>
          <li class="novo-form-row">
            <app-filter-option-toggle [formGroup]="cleanOptionsForm" label="Has File Attachments" controlName="hasFileAttachment"
                               (toggle)="onHasFileAttachmentChange($event)"></app-filter-option-toggle>
          </li>
          <li class="novo-form-row">
            <app-filter-option-toggle [formGroup]="cleanOptionsForm" label="No File Attachments" controlName="noFileAttachment"
                               (toggle)="onNoFileAttachmentChange($event)"></app-filter-option-toggle>
          </li>
        </ul>
        <ul class="filter-section">
          <li matTooltip="Select all in the section" matTooltipPosition="right">
              <i class="bhi-job option-group-icon" (click)="selectSection($event,'submissions,sendouts,interviews,placements')"></i>
          </li>
          <li class="novo-form-row has-icon">
            <app-filter-option-toggle [formGroup]="cleanOptionsForm" label="No Submissions" controlName="submissions"
                               icon="bhi-edit-o"
                               (toggle)="calculateTotal($event, 'submissions')"></app-filter-option-toggle>
          </li>
          <li class="novo-form-row has-icon">
            <app-filter-option-toggle [formGroup]="cleanOptionsForm" label="No Sendouts" controlName="sendouts"
                               icon="bhi-send" (toggle)="calculateTotal($event, 'sendouts')"></app-filter-option-toggle>
          </li>
          <li class="novo-form-row has-icon">
              <app-filter-option-toggle [formGroup]="cleanOptionsForm" label="No Interviews" controlName="interviews"
                                 icon="bhi-calendar"
                                 (toggle)="calculateTotal($event, 'interviews')"></app-filter-option-toggle>
          </li>
          <li class="novo-form-row has-icon">
              <app-filter-option-toggle [formGroup]="cleanOptionsForm" label="No Placements" controlName="placements"
                                 icon="bhi-certification"
                                 (toggle)="calculateTotal($event, 'placements')"></app-filter-option-toggle>
          </li>
        </ul>
        <ul class="filter-section">
          <li matTooltip="Select all in the section" matTooltipPosition="right">
              <i class="bhi-calendar option-group-icon" (click)="selectSection($event,'futureTasks,futureAppointments')"></i>
          </li>
          <li class="novo-form-row">
            <app-filter-option-toggle [formGroup]="cleanOptionsForm" label="No Future Tasks" controlName="futureTasks"
                               (toggle)="calculateTotal($event, 'futureTasks')"></app-filter-option-toggle>
          </li>
          <li class="novo-form-row">
            <app-filter-option-toggle [formGroup]="cleanOptionsForm" label="No Future Appointments" controlName="futureAppointments"
                               (toggle)="calculateTotal($event, 'futureAppointments')"></app-filter-option-toggle>
          </li>
        </ul>
      </ul>
    </div>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        Other Search options
      </mat-expansion-panel-header>
      <div id="other-search-options" class="novo-form-row" matTooltip="Give your search a name." matTooltipPosition="below">
        <div class="switchText">Search Name:</div>
<!--            TODO: move to form control -->
        <input matInput class="text-input" [(ngModel)]="search.searchName" [ngModelOptions]="{standalone: true}" (input)="updateChange()">
      </div>
      <div class="novo-form-row" matTooltip="Custom search terms to added the fields above."
           matTooltipPosition="below">
        <div class="switchText">Query:</div>
        <input matInput class="text-input" formControlName="customSearchQueryTerm" (blur)="calculateTotal(); updateChange()">
      </div>
    </mat-expansion-panel>
      <!-- TODO: This should be a child form group and potentially component -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        Search for records by date added
      </mat-expansion-panel-header>
      <div class="novo-form-row"
           matTooltip="This will search from the entered date back in time."
           matTooltipPosition="below">
        <div class="switchText">Date Added Before</div>
        <div class="datepicker-container">
          <input #dateAddedBeforeInput matInput [matDatepicker]="picker_dateAddedBefore" placeholder="mm/dd/yyyy"
                 (click)="picker_dateAddedBefore.open()"
                 formControlName="dateAddedBefore">
          <mat-datepicker-toggle matSuffix [for]="picker_dateAddedBefore" [disableRipple]="true"></mat-datepicker-toggle>
          <mat-datepicker #picker_dateAddedBefore (opened)="refocusInput(dateAddedBeforeInput)"></mat-datepicker>
        </div>
        <i *ngIf="cleanOptionsForm.get('dateAddedBefore')?.value" class="bhi-times clear-date"
           (click)="clearDateAddedBefore()" (keydown.enter)="clearDateAddedBefore()"
           [matTooltip]="'Remove this date'" tabindex="0" matTooltipPosition="right" matTooltipShowDelay="500"></i>
      </div>
      <div class="novo-form-row" matTooltip="This will search records added with the interval specified."
           matTooltipPosition="below">
        <div class="switchText">Date Added Within Last</div>
        <mat-select formControlName="dateAddedWithin" panelClass="dc-dropdown-250" (selectionChange)="calculateTotal(); updateChange()">
          <mat-option *ngFor="let o of dayIntervals.options" [value]="o.value">{{o.label}}</mat-option>
        </mat-select>
      </div>
    </mat-expansion-panel>
      <!-- TODO: This should be a child form group and component -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>Notes
      </mat-expansion-panel-header>
        <div class="novo-form-row"
             matTooltip="This will search from the entered date back in time. It will also show records with no notes."
             matTooltipPosition="above">
        <div class="switchText">Last Note Added Before</div>
            <div class="datepicker-container">
                <input #lastNoteAddedBeforeInput matInput [matDatepicker]="picker_dateLastComment" placeholder="mm/dd/yyyy"
                       (click)="picker_dateLastComment.open()" (dateChange)="calculateTotal(); updateChange()"
                       formControlName="dateLastComment">
                <mat-datepicker-toggle matSuffix [for]="picker_dateLastComment" [disableRipple]="true"></mat-datepicker-toggle>
                <mat-datepicker #picker_dateLastComment (opened)="refocusInput(lastNoteAddedBeforeInput)"></mat-datepicker>
            </div>
          <i *ngIf="cleanOptionsForm.get('dateLastComment')?.value" class="bhi-times clear-date"
             (click)="clearDateLastComment()" (keydown.enter)="clearDateLastComment()"
             [matTooltip]="'Remove this date'" tabindex="0" matTooltipPosition="right" matTooltipShowDelay="500")></i>
        </div>
      <div class="note-types">
        <p>Adding note actions here will not update the estimated 'total' due to performance limitations. As a result,
          final numbers may be lower.</p>
        <div class="novo-form-row note-form-row">
          <span class="switchText">Include Note Types</span>
          <mat-select formControlName="includeNoteTypes" (selectionChange)="updateChange()" multiple>
            <mat-option *ngFor="let o of noteActions" [value]="o">{{o}}</mat-option>
          </mat-select>
        </div>
        <div class="novo-form-row note-form-row">
          <span class="switchText">Exclude Note Types</span>
          <mat-select formControlName="excludeNoteTypes" (selectionChange)="updateChange()" multiple>
              <mat-option *ngFor="let o of noteActions" [value]="o">{{o}}</mat-option>
          </mat-select>
        </div>
      </div>
    </mat-expansion-panel>
      <!-- TODO: This should be a child form group and component.  -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>What should happen when the Search is completed?
      </mat-expansion-panel-header>
      <ul class="filter-section post-search-actions-list">
        <li class="novo-form-row expansion-panel-subgroup flex-align-center">
          <mat-slide-toggle [ngClass]="{'disabled-toggle' : !postSearchActions.EMAIL_NOTIFICATION}"
                  [(ngModel)]="postSearchActions.EMAIL_NOTIFICATION" [ngModelOptions]="{standalone: true}" (change)="updateChange()">Let me know by email</mat-slide-toggle>
          <div *ngIf="postSearchActions.EMAIL_NOTIFICATION" class="novo-form-row "
               matTooltip="Notification email alert." matTooltipPosition="below">
              <input matInput id="email-form-field" class="text-input" placeholder='Your email' [(ngModel)]="emailNotification" [ngModelOptions]="{standalone: true}" (input)="updateChange()">
          </div>
        </li>
      </ul>
      <ul class="filter-section post-search-actions-list">
        <li class="novo-form-row expansion-panel-subgroup">
          <mat-slide-toggle [ngClass]="{'disabled-toggle' : !postSearchActions.CREATE_TEARSHEET}"
                            [(ngModel)]="postSearchActions.CREATE_TEARSHEET" [ngModelOptions]="{standalone: true}"
                            (change)="updateChange()">Create Tearsheet</mat-slide-toggle>
          <div class="note-types" *ngIf="postSearchActions.CREATE_TEARSHEET">
            <h2 class="heading-underline">What group of people should be on the tearsheet?</h2>
            <div class="novo-form-row">
              <span class="switchText">Date Added group</span>
              <mat-select panelClass="dc-dropdown-250" [(ngModel)]="tearsheetGroups.dateAdded" [ngModelOptions]="{standalone: true}" (selectionChange)="updateChange()" multiple>
                <mat-option *ngFor="let o of peopleGroups.options" [value]="o.name">{{o.label}}</mat-option>
              </mat-select>
            </div>
            <div class="novo-form-row">
              <span class="switchText">Date Last note group</span>
              <mat-select panelClass="dc-dropdown-250" [(ngModel)]="tearsheetGroups.dateLastComment" [ngModelOptions]="{standalone: true}" (selectionChange)="updateChange()" multiple>
                <mat-option *ngFor="let o of peopleGroups.options" [value]="o.name">{{o.label}}</mat-option>
              </mat-select>
            </div>
            <div class="novo-form-row">
              <span class="switchText">Date Last activity</span>
              <mat-select panelClass="dc-dropdown-250" [(ngModel)]="tearsheetGroups.dateLastActivity" [ngModelOptions]="{standalone: true}" (selectionChange)="updateChange()" multiple>
                <mat-option *ngFor="let o of peopleGroups.options" [value]="o.name">{{o.label}}</mat-option>
              </mat-select>
            </div>
            <h2 class="heading-underline">Tearsheet Owner</h2>
            <div class="novo-form-row tearsheet-owner" id="tearsheet-owner">
              <span class="switchText">Owner</span>
                <input id="owner-input" [matAutocomplete]="owner" matInput type="text" placeholder="Owner"
                       [(ngModel)]="tearsheetOwnerDisplay"
                       [ngModelOptions]="{standalone: true}"
                       (input)="filterUsers($event.target.value); updateChange()">
                <mat-autocomplete #owner="matAutocomplete"
                                  (optionSelected)="onUserSelected($event.option.value)">
                    <mat-option *ngFor="let user of filteredUsers" [value]="user">
                        {{ user.name }}
                    </mat-option>
                </mat-autocomplete>
            </div>
          </div>
        </li>
      </ul>
      <ul class="filter-section post-search-actions-list">
        <li class="novo-form-row expansion-panel-subgroup">
          <mat-slide-toggle [ngClass]="{'disabled-toggle' : !postSearchActions.RUN_AGAIN}"
                  [(ngModel)]="postSearchActions.RUN_AGAIN" [ngModelOptions]="{standalone: true}" (change)="updateChange()">Run Repeatedly</mat-slide-toggle>
          <div class="note-types" *ngIf="postSearchActions.RUN_AGAIN">
            <h2 class="heading-underline">How often would you like this to run?</h2>
            <div class="novo-form-row">
              <span class="switchText">Every </span>
              <mat-select panelClass="dc-dropdown-250" [(ngModel)]="runAgainOptions.repeatDays" [ngModelOptions]="{standalone: true}" (selectionChange)="updateChange()">
                <mat-option *ngFor="let o of dayIntervals.options" [value]="o.value">{{o.label}}</mat-option>
              </mat-select>
            </div>
          </div>
        </li>
      </ul>
    </mat-expansion-panel>
    <mat-expansion-panel id="run-time-toggle">
      <mat-expansion-panel-header>When would you like this to run?
      </mat-expansion-panel-header>
      <ng-container *ngFor="let option of scheduledOptions">
        <button (click)="changeScheduledSearch(option.value)" theme="nav"
                [ngClass]="[option.value === scheduledSearch ? 'checked' : 'unchecked']"
                (selectionchange)="updateChange()" appRipple>{{option.label}}
        </button>
      </ng-container>
      <div *ngIf="scheduledSearch=='later'" class="novo-form-row start-later-pickers" matTooltip="Start date/time" matTooltipPosition="below">
        <div class="run-time-toggle-text">Select date/time:</div>
        <div class="datepicker-container">
            <mat-label>Date</mat-label>
            <input matInput [matDatepicker]="datepicker" [(ngModel)]="scheduledDateTime" [ngModelOptions]="{standalone: true}"
                   (click)="datepicker.open()" (blur)="timepicker.close()">
            <mat-datepicker #datepicker/>
            <mat-datepicker-toggle [for]="datepicker" matSuffix/>
        </div>
        <div class="datepicker-container">
            <mat-label>Time</mat-label>
            <input matInput [matTimepicker]="timepicker" [(ngModel)]="scheduledDateTime"
                   [ngModelOptions]="{updateOn: 'blur', standalone: true}" (click)="timepicker.open()"
                   (blur)="timepicker.close()">
            <mat-timepicker #timepicker interval="1m"/>
            <mat-timepicker-toggle [for]="timepicker" matSuffix/>
        </div>
    </div>
    </mat-expansion-panel>
    <section class="footer-btns stretch-btns">
      <button (click)="scheduleLater()"
              [disabled]="numRecordsFoundTooMany() || scheduledSearch=='now' || !scheduledTimeIsAfterNow() || !checkRunAgain() || (!cleanOptionsForm.dirty)"
              appRipple>{{(!isScheduled) ? 'Schedule Later' : 'Update Scheduled Search'}}<i class="bhi-viewall"></i></button>
      <button
              (click)="runSearch()"
              [disabled]="numRecordsFoundTooMany()
                || !getCreateTearsheetSelected()
                || !getEmailSelected()
                || !checkRunAgain()
                || scheduledSearch=='later'
                || isNumRecordsFoundZero()"
              appRipple>Run Now<i class="bhi-viewall"></i></button>
    </section>
  </form>
</article>
